import { makeReducer } from '../utils/redux.tools';
import { TemplatesActions } from '../actions/templates.actions';

export const initialState = {
    templates: [],
    template: {}
};

const templatesRed = {
    [TemplatesActions.FETCH_TEMPLATE_NAMES]: (state, payload) => ({
        ...state,
        templates: payload
    }),
    [TemplatesActions.FETCH_SINGLE_TEMPLATE_RETURN]: (state, payload) => ({
        ...state,
        template: payload
    }),
    [TemplatesActions.CLEAR_SINGLE_TEMPLATE]: state => ({
        ...state,
        template: {}
    })
};

export const templatesReducer = makeReducer('Templates', initialState, templatesRed);
